"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = void 0;
exports.error = function (msg) {
    throw new Error(msg);
};
//# sourceMappingURL=errors.js.map